export const SessionDataMap = {
  'cacheData.data.AriesReservation.tripsXRequestedByHeader': 'tripsXRequestedByHeader',
  'cacheData.data.AriesReservation.tripId': 'tripId',
  'cacheData.data.consumerID': 'consumerID',
  'cacheData.data.AriesReservation.shoppingCartId': 'cartId',
  'cacheData.data.AriesReservation.propertyId': 'propertyId',
  'cacheData.data.AriesSearch.searchCriteria.selectedCurrency': 'searchSelectedCurrency',
  'cacheData.data.AriesReservation.selectedCurrency': 'resSelectedCurrency',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numGuestsPerRoom': 'numGuestsPerRoom',
  locale: 'locale',
  'cacheData.data.AriesReservation.isACRS': 'isACRS',
  'cacheData.data.AriesReservation.crsSystem': 'crsSystem',
};

export const SummaryChargesOrderMap = {
  'commerce.order.orderByConfirmationNumber.items[0].basicInformation.lengthOfStay': 'lengthOfStay',
  'commerce.order.orderByConfirmationNumber.items[0].basicInformation.isRedemption': 'isRedemption',
  'commerce.order.orderByConfirmationNumber.items': 'trips',
  'commerce.order.orderByConfirmationNumber.totalPricing.grandTotal': 'cashTotal',
  'commerce.order.orderByConfirmationNumber.totalPricing.grandTotal.currency': 'currency',
  'commerce.order.orderByConfirmationNumber.redemptionDetail.totalPoints': 'totalPoint',
  'commerce.order.orderByConfirmationNumber.redemptionDetail': 'redemptionDetail',
  'commerce.order.orderByConfirmationNumber.items[0].productType.segments': 'segments',
  'customer.loyaltyInformation.rewards.currentPointBalance': 'currentPointBalance',
  'catalog.propertyById.transportation': 'transportationOptions',
  'commerce.order.orderByConfirmationNumber.items[0].totalPricing': 'totalPricingPerRoom',
  'commerce.order.orderByConfirmationNumber.items[0].totalPricing.subtotal.amount': 'subtotalWithNRP',
  'commerce.order.orderByConfirmationNumber.items[0].totalPricing.subtotal.decimalPoint': 'subtotalDecimalPoint',
};

export const SummaryChargesCartMap = {
  'commerce.cart.cartById.totalPricing.grandTotal': 'cashTotal',
  'commerce.cart.cartById.totalPricing.grandTotal.currency': 'currency',
  'commerce.cart.cartById.itemGroups[0].items': 'cartItems',
  'commerce.cart.cartById.itemGroups[0].items[0].totalPricing': 'totalPricingPerRoom',
  'commerce.cart.cartById.itemGroups[0].items[0].quantity': 'noOfRooms',
  'commerce.cart.cartById.itemGroups[0].items[0].redemptionDetail': 'redemptionDetail',
  'commerce.cart.cartById.itemGroups[0].items[0].productType.segments': 'segments',
  'commerce.cart.cartById.itemGroups[0].items[0].totalPricing.subtotal.amount': 'subtotalWithNRP',
  'commerce.cart.cartById.itemGroups[0].items[0].totalPricing.subtotal.decimalPoint': 'subtotalDecimalPoint',
  'commerce.cart.cartById.itemGroups[0].redemptionDetail.pointsRequiredToRedeem': 'totalPoint',
  'commerce.cart.cartById.itemGroups[0].redemptionDetail.fullPointsRecommendation.pointsRequiredToRedeem':
    'totalpointsWithoutFNA',
  'catalog.propertyById.transportation': 'transportationOptions',
};

export const SummaryChargesCartSegmentMap = {
  'product.rateDetails': 'rateSegment',
  'product.rate.isGuestViewable': 'isGuestViewable',
  'product.basicInformation.lengthOfStay': 'nightCountValue',
  'product.rateDetails[0].isRedemption': 'isRedemption',
  'product.totalPricing': 'productTotalPricing',
};

export const SummaryOfChargesCartAvailableAddons = {
  'availableAddOns.nonRoomProductAddOns': 'nonRoomProductAddOns',
};

export const SummaryChargesOrderSegmentMap = {
  'product.basicInformation.lengthOfStay': 'lengthOfStay',
  'product.rateDetails': 'rateSegment',
  'product.rate.isGuestViewable': 'isGuestViewable',
  'product.totalPricing': 'productTotalPricing',
};
